module.exports = __webpack_public_path__ + "img/hover-call.5c3c7769.png";